import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TraitsApi } from '@kp/traits/traits.api';
import { Traits } from '@kp/traits/traits.model';
import { DataStatus, Status } from '@ktypes/models';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TraitsBloc {
  constructor(public router: Router, private _traitsApi: TraitsApi) {}

  get traitsSubject$(): Observable<DataStatus<Traits>> {
    return this._traitsSubject.asObservable();
  }

  private _traitsSubject: BehaviorSubject<DataStatus<Traits>> = new BehaviorSubject<DataStatus<Traits>>(null);

  refreshTraits(): void {
    this._traitsSubject.next(new DataStatus<Traits>(Status.starting, null, null));
    this._traitsApi.getTraits().then((traits) => {
      if (traits) {
        this._traitsSubject.next(new DataStatus<Traits>(Status.done, null, traits));
      }
    });
  }
}
